import Vue from 'vue';
import Vuex from 'vuex';
import VueJwtDecode from 'vue-jwt-decode';
import router from '../router';
import VueCookies from 'vue-cookies';
import {
    loginUser,
    socialLoginUser,
    updateDomainPackClient
} from '../components/shared/services/user.service';

Vue.use(VueCookies);
Vue.use(Vuex);

function handleAuthentication({commit}, response, userData) {
    const tokenDecoded = VueJwtDecode.decode(response.data.token);
    let user;
    if(userData && userData.idSelectedDomain != null){
         user = {
            roles: tokenDecoded.roles,
            email: tokenDecoded.username,
            firstName: tokenDecoded.firstname,
            lastName: tokenDecoded.lastname,
            id: tokenDecoded.id,
            idSelectedDomain: userData.idSelectedDomain ? userData.idSelectedDomain: null,
            idSelectedPack: userData.idSelectedPack ? userData.idSelectedPack: null
        };
    }else{
        if(JSON.parse(response.config.data).idSelectedPack!= null){
            user = {
                roles: tokenDecoded.roles,
                email: tokenDecoded.username,
                firstName: tokenDecoded.firstname,
                lastName: tokenDecoded.lastname,
                id: tokenDecoded.id,
                idSelectedDomain: JSON.parse(response.config.data).idSelectedDomain? JSON.parse(response.config.data).idSelectedDomain: null,
                idSelectedPack: JSON.parse(response.config.data).idSelectedPack? JSON.parse(response.config.data).idSelectedPack : null
            };

        }else{
            user = {
                roles: tokenDecoded.roles,
                email: tokenDecoded.username,
                firstName: tokenDecoded.firstname,
                lastName: tokenDecoded.lastname,
                id: tokenDecoded.id,
            };
        }
    }
    let token = {
        token: response.data.token,
        refresh_token: response.data.refresh_token,
        expiresIn: tokenDecoded.exp
    };
    if(userData && userData.idSelectedPack != null && userData.idSelectedDomain != null){
        updateDomainPackClient(userData.idSelectedDomain, userData.idSelectedPack, user.id).then(response =>{
            user.idSelectedDomain = response.data.idSelectedDomain
        });
    }
    Vue.$cookies.set('user', user);
    Vue.$cookies.set('token', token);
    commit('authUser', {
        token: token,
        user: user
    });
    router.push('/');
}

export default new Vuex.Store({
    state: {
        token: {
            token: null,
            refresh_token: null,
            expiresIn: null
        },
        user: {
            roles: null,
            email: null,
            firstName: null,
            lastName: null,
            id: null,
            idSelectedDomain: null,
            idSelectedPack: null
        }
    },
    mutations: {
        authUser(state, userData) {
            state.token = userData.token;
            state.user = userData.user;
        },
        clearAuthData(state) {
            state.token = {
                token: null,
                refresh_token: null,
                expiresIn: null
            };
            state.user = {
                roles: null,
                email: null,
                firstName: null,
                lastName: null,
                id: null,
                idSelectedDomain: null,
                idSelectedPack: null
            };
        }
    },
    actions: {
        handle({commit}, userData) {
            handleAuthentication({commit}, userData);
        },
        signin({commit}, userData) {
            return new Promise((resolve, reject) => {
                loginUser(userData.email, userData.password)
                    .then(response => {
                        handleAuthentication({commit}, response, userData);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response.data);
                    });
            });
        },
        socialSignIn({commit}, data) {
            return new Promise((resolve, reject) => {
                socialLoginUser(data.provider, data.token)
                    .then(response => {
                        handleAuthentication({commit}, response);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        tryAutoLogin({commit}) {
            const token = Vue.$cookies.get('token');
            if (!token) {
                return;
            }
            const user = Vue.$cookies.get('user');
            commit('authUser', {
                token: token,
                user: user
            });
        },
        logout({commit}) {
            commit('clearAuthData');
            Vue.$cookies.remove('token');
            Vue.$cookies.remove('user');
            Vue.$cookies.remove('role');
            Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie));
            location.reload();
            router.push({name: 'login'});
        }
    },
    getters: {
        user(state) {
            return state.user;
        },
        getValues: state => state.user.roles,
        role(state) {
            if (state.user.roles && state.user.roles.length > 0) {
                return state.user.roles[0];
            } else {
                return state.user.roles;
            }
        },
        isAuthenticated(state) {
            return state.token.token != null;
        }
    }
});
